import React, { useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import CustomSelect from "components/CustomSelect";
import PubSub from 'services/PubSub/';
import TagManagerService from 'services/TagManager';
import queryString from 'query-string';
import orderIcon from 'images/icons/order-icon.svg';
import style from './style.scss';//NOSONAR

let actions = [];

const OrderBy = (props) => {
    const [isOrderOpened, setIsOrderOpened] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState(null);

    let options = [
        { value: 'OrderByTopSaleDESC', label: 'Más vendido' },
        { value: 'OrderByBestDiscountDESC', label: 'Mejor descuento' },
        { value: 'OrderByPriceDESC', label: 'Mayor precio' },
        { value: 'OrderByPriceASC', label: 'Menor precio' },
        { value: 'OrderByNameASC', label: 'A - Z' },
        { value: 'OrderByNameDESC', label: 'Z - A' },
        { value: 'OrderByReleaseDateDESC', label: 'Más nuevo' },
    ];

    useEffect(() => {
        actions.push(PubSub.register('catalog_toogleFilter', onToogleFilter));
    
        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];

        }
    }, []);

    const change = (selectedOption) => {
        setSelectedOptions(selectedOption);
        PubSub.dispatch('filter_setOrder', {order: selectedOption.value});
        
        let title= props.title;
        const params = queryString.parse(window.location.search);
                
        if(title === "Búsqueda: " && params.nombre_promo){
            title = 'oferta: ' + params.nombre_promo;
        }
        
        TagManagerService.interaction(title, selectedOption.label);
    }
        
    const onToogleFilter = (payload) => {
        setIsOrderOpened(payload.value.isOrderOpened || false);
    }
        
    const closeOrder = () => {
        setIsOrderOpened(false);
    }
        
    const selectOption = (value) => {
        let selected = value;
        let newSelection = options.filter(item => item.value === selected)[0];
        
        if(newSelection) {
            setTimeout(() => {
                PubSub.dispatch('filter_setOrder', {order: newSelection.value});
            }, 1000);
            setIsOrderOpened(false);
        }
        
        props.orderBy(newSelection.label);
        setSelectedOptions(newSelection);
        
        let title= props.title;
        const params = queryString.parse(window.location.search);
                
        if(title === "Búsqueda: " && params.nombre_promo){
            title = 'oferta: ' + params.nombre_promo;
        }
        
        TagManagerService.interaction(title, newSelection.label);
    }

    return (
        <>
            <div className={"order-by-wrap" + (isOrderOpened ? ' open-order' : '')}>
                <div className="order-by-title"><i dangerouslySetInnerHTML={{ __html: orderIcon }} className="order-icon-mobile"></i> Ordenar</div>
                <div className={'shelf-header-order-by'}>
                    {options.map((items, i) => {
                        return (
                            <label key={i} className="order-by-wrap-options">
                                <input type="radio" name="order" className={"order-by-input"} value={items.value} onClick={() => selectOption(items.value)}/>
                                <span className="order-by-option-title">{items.label}</span>
                            </label>
                        )
                    })}
        
                    <CustomSelect options={options} className={'select'} classNamePrefix="select" value={selectedOptions}  onChange={change} placeholder={options[0].label}/>
                </div>
            </div>
            <span className={"order-by-wrap-bg"+ (isOrderOpened ? ' active' : '')} onClick={closeOrder}/>
        </>
    )  
}

OrderBy.propTypes = {
    order: PropTypes.string,
    title: PropTypes.string,
    orderBy: PropTypes.func
}

export default OrderBy;
